export function getAllReferences(array) {
  try {
    return array.map((item) => item.reference);
  } catch (error) {
    console.error("Error in getAllReferences:", error);
    return [];
  }
}
